/*
 * CalendarSubscription Messages
 *
 * This contains all the text for the CalendarSubscription component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  calendarSubscription: {
    id: 'app.containers.CalendarSubscription.calendarSubscription',
    defaultMessage: 'Calendar Subscription',
  },
  enableCalendarSubscription: {
    id: 'app.containers.CalendarSubscription.enableCalendarSubscription',
    defaultMessage: 'Enable Calendar Subscription',
  },
  enableCalendarSubscriptionSuccess: {
    id: 'app.containers.CalendarSubscription.enableCalendarSubscriptionSuccess',
    defaultMessage: 'Successfully enabled calendar subscription',
  },
  enableCalendarSubscriptionFailure: {
    id: 'app.containers.CalendarSubscription.enableCalendarSubscriptionFailure',
    defaultMessage: 'Enabling calendar subscription failed!',
  },
  disableCalendarSubscription: {
    id: 'app.containers.CalendarSubscription.disableCalendarSubscription',
    defaultMessage: 'Disable Calendar Subscription',
  },
  disableCalendarSubscriptionSuccess: {
    id: 'app.containers.CalendarSubscription.disableCalendarSubscriptionSuccess',
    defaultMessage: 'Successfully disabled calendar subscription',
  },
  disableCalendarSubscriptionFailure: {
    id: 'app.containers.CalendarSubscription.disableCalendarSubscriptionFailure',
    defaultMessage: 'Disabling calendar subscription failed!',
  },
  copyCalendarSubscriptionUrl: {
    id: 'app.containers.CalendarSubscription.copyCalendarSubscriptionUrl',
    defaultMessage: 'Copy Link',
  },
  calendarSubscriptionDescriptionTitle: {
    id: 'app.containers.CalendarSubscription.calendarSubscriptionDescriptionTitle',
    defaultMessage: 'What do I do with this link?',
  },
  calendarSubscriptionDescription1: {
    id: 'app.containers.CalendarSubscription.calendarSubscriptionDescription1',
    defaultMessage:
      'The above link is a your personal calendar feed. Most digital calendars support subscribing to external calendars via such links. Once you add this link to your digital calendar you will always get your applications and assignments synced to your calendar automatically.',
  },
  calendarSubscriptionDescription2: {
    id: 'app.containers.CalendarSubscription.calendarSubscriptionDescription2',
    defaultMessage:
      'Here are a couple of helpful links for adding the above calendar link to your own calendar:',
  },
  googleCalendarLink: {
    id: 'app.containers.CalendarSubscription.googleCalendarLink',
    defaultMessage: 'Google Calendar',
  },
  appleIcloudCalendarLink: {
    id: 'app.containers.CalendarSubscription.appleIcloudCalendarLink',
    defaultMessage: 'Apple iCloud Calendar',
  },
  microsoftOutlookCalendarLink: {
    id: 'app.containers.CalendarSubscription.microsoftOutlookCalendarLink',
    defaultMessage: 'Microsoft Outlook Calendar',
  },
});
